import getContractAddresses from "../contractData/contractAddress/addresses";
import { web3 } from "../web3";
import claim from "../contractData/abis/claim.json";
import merkleABI from "../contractData/abis/merkleABI.json";
import tokenABI from "../contractData/abis/token.json";
import linearVestingABI from "../contractData/abis/lenearVesting.json";
import { networkProviders } from "./metamask";
const keccak256 = require("keccak256");
const { MerkleTree } = require("merkletreejs");

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export function TimeStampToDateString(val) {
  const dateString = new Date(Number(val) * 1000);
  var year = dateString.getFullYear();
  // month as 2 digits (MM)
  var month = dateString.getMonth();
  // date as 2 digits (DD)
  var date = ("0" + dateString.getUTCDate()).slice(-2);
  var hrs = ("0" + dateString.getUTCHours()).slice(-2);
  var min = ("0" + dateString.getUTCMinutes()).slice(-2);
  var sec = ("0" + dateString.getUTCSeconds()).slice(-2);
  let d = `${year}-${months[month]}-${date} ${hrs}:${min} UTC`;
  return d;
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function compactAddress(address) {
  const newAddress = address;
  if (address) {
    const res =
      newAddress.substring(0, 4) +
      "..." +
      newAddress.substring(newAddress.length - 4, newAddress.length);
    return res;
  }
}

export function getContractInstance(
  network,
  currentchain,
  contractAddress,
  contractType
) {
  let currentABI =
    contractType === "token"
      ? tokenABI
      : contractType === "linear"
      ? linearVestingABI
      : contractType === "merkle"
      ? merkleABI
      : claim;
  let currentProvoider = currentchain ? web3 : networkProviders[network];
  try {
    if (web3) {
      const contractInstance = new currentProvoider.eth.Contract(
        currentABI,
        contractAddress
      );

      return contractInstance;
    }
  } catch (error) {
    console.log(error);
  }
}

export const createRootHash = (userArr) => {
  const leaf = userArr.map((claimToken) => call(claimToken));
  const merkleTree = new MerkleTree(leaf, keccak256, { sortPairs: true });
  const root = merkleTree.getRoot();
  return "0x" + root.toString("hex");
};

const merkleTreeInstance = (userArr) => {
  const leaf = userArr.map((claimToken) => call(claimToken));
  const merkleTree = new MerkleTree(leaf, keccak256, { sortPairs: true });
  return merkleTree;
};

export const createMerkleProof = (walletAddress, eTokens, userArr) => {
  const merkleTree = merkleTreeInstance(userArr);
  const hexProof = merkleTree.getHexProof(
    call({
      walletAddress,
      eTokens,
    })
  );
  return hexProof;
};
const call = (claimToken) => {
  return web3.utils.soliditySha3(
    { type: "address", value: claimToken.walletAddress },
    { type: "uint256", value: claimToken.eTokens }
  );
};

let existingCsv = null;
export const getHexProofs = (id, walletAddress, vestingId) => {
  return new Promise((resolve, reject) => {
    let url2 = `https://snapshotapi.seedify.fund/api/v1/claim/create-hexproof?dumpId=${id}&walletAddress=${walletAddress}&vestingId=${vestingId}`;
    fetch(url2)
      .then((response) => response.json())
      .then((data) => {
        resolve(data.data.vestings);
      })
      .catch(() => reject(false));
  });
};
export const getCSV = (id, walletAddress) => {
  return new Promise((resolve, reject) => {
    if (existingCsv && id === existingCsv?.data._id) {
      resolve(existingCsv.data.dumpId.uploadData);
    } else {
      let url1 = `https://snapshotapi.seedify.fund/api/v1/claim/single/${id}?csvData=true`;
      fetch(url1)
        .then((response) => response.json())
        .then((data) => {
          existingCsv = data;
          resolve(data.data.dumpId.uploadData);
        })
        .catch(() => reject(false));
    }
  });
};
